import { getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

export type CurrencyFormat = 'wide' | 'narrow';

@Pipe({
  name: 'currencySymbol'
})
export class CurrencySymbolPipe implements PipeTransform {
  transform(code: string, format: CurrencyFormat = 'narrow', locale?: string): any {
    return getCurrencySymbol(code, format, locale);
  }
}
